module.exports = require("vuetify/lib");